<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</span>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">

	<span style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</span>
</div>

<div class="row_1">
	<div class="top_grid_agg">
		<div class="content">
          <div style="width: 50%; justify-content: left; display: flex;">
            <button routerLink="/newtask" class="back_button col-sm-1">BACK</button>
          </div>
		  <div style="width: 50%; justify-content: right; display: flex;">
            <button class="add_button col-sm-1 float-right" (click)="addtask()">ADD TASK</button>
          </div>
        </div>
		<div class="period-form">
			<form class="form-horizontal hr">
				<div class="form-group row">
					<div class="col-sm-6">

						<div class="board-row">
							<label class="control-label col-sm-4">Board:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<select [(ngModel)]="selected_board" [ngModelOptions]="{standalone: true}">
									<option *ngFor="let board of boardData" [value]="board.boardID">
										{{board.description}}
									</option>
								</select>
							</div>
						</div>

						<div class="task-row">
							<label class="control-label col-sm-4">Task:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<!-- <select class="category" [(ngModel)]="selectedTask"
									[ngModelOptions]="{standalone: true}">
									<option *ngFor="let task of taskData" [value]="task.taskID">
										{{task.description}}
									</option>
								</select> -->
								
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selectedTask" placeholder="Select" name="taskSelect"
										panelClass="custom-task-panel">

										<!-- Search -->
										<mat-option disabled>
											<ngx-mat-select-search [formControl]="taskFilter" placeholderLabel="Search"
												noEntriesFoundLabel="No User found">
											</ngx-mat-select-search>
										</mat-option>

										<!-- Options -->
										<mat-option *ngFor="let user of filteredTasks | async" [value]="user">
											{{ user.label }}
										</mat-option>

									</mat-select>
								</mat-form-field>
							</div>
						</div>

						<div class="startweek-row">
							<label class="control-label col-sm-4">Start Week:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								
								<select class="category" [(ngModel)]="selected_startweek"
									[ngModelOptions]="{standalone: true}">
									<option *ngFor="let week of weekData" [value]="week.ID">
										{{week.description}}
									</option>
								</select>

							</div>
						</div>

						<div class="recur-row">
							<label class="control-label col-sm-4">Recur every Week(s):</label>
							<div class="col-sm-8">
								<input type="number" min="1" max="4" [(ngModel)]="selected_recureveryweek"
									[ngModelOptions]="{standalone: true}" onKeyDown="return false">
							</div>
						</div>

						<div class="occurance-row">
							<label class="control-label col-sm-4">Occurences:</label>
							<div class="col-sm-8">
								<input type="number" min="1" max="50" [(ngModel)]="selected_occurance"
									[ngModelOptions]="{standalone: true}" onKeyDown="return false">
							</div>
						</div>

						<div class="due-row">
							<label class="control-label col-sm-4">Due Time:
								<p class="due-desc">(Leave blank for midnight) &nbsp;</p>

							</label>
							<div class="col-sm-8">
								<select id="category-drop-down" class="dueTime" [(ngModel)]="selected_duetime"
									[ngModelOptions]="{standalone: true}">
									<option [value]="option" *ngFor="let option of options">{{option}}</option>
								</select>
							</div>
						</div>

						<!-- bind dayofWeek -->
						<div class="daysoftheweek-row">
							<label class="control-label col-sm-4">Day(s) of the week:
								<span style="color:#ff0000">*</span>
							</label>
							<div class="daysoftheweek-checkbox col-sm-8" style="display: flex;">
								<input class="sun" type="checkbox" [(ngModel)]="selected_sun"
									[ngModelOptions]="{standalone: true}">
								<span id="sun">Sun</span>

								<input class="mon" type="checkbox" [(ngModel)]="selected_mon"
									[ngModelOptions]="{standalone: true}"><span id="mon">Mon</span>

								<input class="tue" type="checkbox" [(ngModel)]="selected_tue"
									[ngModelOptions]="{standalone: true}"><span id="tue">Tue</span>

								<input class="wed" type="checkbox" [(ngModel)]="selected_wed"
									[ngModelOptions]="{standalone: true}"><span id="wed">Wed</span>

								<input class="thu" type="checkbox" [(ngModel)]="selected_thur"
									[ngModelOptions]="{standalone: true}"><span id="thu">Thur</span>

								<input class="fri" type="checkbox" [(ngModel)]="selected_fri"
									[ngModelOptions]="{standalone: true}"><span id="fri">Fri</span>

								<input class="sat" type="checkbox" [(ngModel)]="selected_sat"
									[ngModelOptions]="{standalone: true}"><span id="sat">Sat</span>
							</div>
						</div>

						<div class="primaryuser-row">
							<label class="control-label col-sm-4">Primary User:
								<span *ngIf="s_region_flag" style="color:#ff0000">*</span>
							</label>
							<div class="col-sm-8">
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_puser" name="puser"
												placeholder="Select" >
								
									<mat-option disabled>
										<div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
								
										<ngx-mat-select-search
											[formControl]="puserFilter"
											placeholderLabel="Search"
											noEntriesFoundLabel="No User found"
											style="flex: 1;">
										</ngx-mat-select-search>
										</div>
									</mat-option>
									<div style="max-height: 200px; overflow-y: auto;">

									<mat-option *ngFor="let user of filteredPusers | async" [value]="user">
										{{ user.label }}
									</mat-option>
								</div>
									</mat-select>
								</mat-form-field>
							</div>
						</div>

						<div class="secondaryuser-row">
							<label class="control-label col-sm-4" for="fname">Secondary User:</label>
							<div class="col-sm-8">
								
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_suser" name="suser"
												placeholder="Select" >
								
									<mat-option disabled>
										<div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
								
										<ngx-mat-select-search
											[formControl]="suserFilter"
											placeholderLabel="Search"
											noEntriesFoundLabel="No User found"
											style="flex: 1;">
										</ngx-mat-select-search>
										</div>
									</mat-option>
									<div style="max-height: 200px; overflow-y: auto;">

									<mat-option *ngFor="let user of filteredSusers | async" [value]="user">
										{{ user.label }}
									</mat-option>
								</div>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="col-sm-6">
						<div class="region-row">
							<label class="control-label col-sm-4" for="fname">Region:
								<span *ngIf="!selected_puser" style="color:#ff0000">*</span>
							</label>
							<div class="multiselect col-sm-8">
							
								<mat-form-field appearance="outline" class="fixed-select">
									<mat-select [(ngModel)]="selected_region" name="region"
												[multiple]="true"
												placeholder="Select Region(s)"
												>
								
									<!-- Sticky Select All with Search Row -->
									<mat-option disabled>
										<div style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
										<!-- Real checkbox -->
										<mat-checkbox
											[checked]="isAllSelected()"
											[indeterminate]="isIndeterminate()"
											(change)="toggleSelectAll($event)"
											style="margin-right: 8px;">
										</mat-checkbox>
								
										<!-- Search box -->
										<ngx-mat-select-search
											[formControl]="regionFilterCtrl"
											placeholderLabel="Search"
											noEntriesFoundLabel="No regions found"
											style="flex: 1;">
										</ngx-mat-select-search>
										</div>
									</mat-option>
								
									<!-- Options -->
									<div style="max-height: 200px; overflow-y: auto;">

									<mat-option *ngFor="let user of filteredRegions | async" [value]="user">
										{{ user.label }}
									</mat-option>
								</div>
									</mat-select>
								</mat-form-field>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>